import { IkeFieldType, type SubFormSpanTypeState, SubFormType } from '@ikegps/core-api';
import {
	type CollectionModelFieldSubFormInstance,
	type FormModelField,
	type FormModelFieldSelectList,
	type FormModelFieldState,
	type FormModelFieldSubForm,
	type ISpan,
	type ISpanForm,
	PoleFieldIds,
	SpanSubFormAdaptor,
	SpanTypeOptionSet,
} from '..';

export class SpanSubForm implements ISpanForm {
	private subFormSpanTypeState: SubFormSpanTypeState;
	constructor(public spanField: FormModelFieldSubForm) {
		if (this.spanField.subFormType !== SubFormType.SPAN) {
			throw new Error("SubForm instance's schema must have type SPAN to be passed into SpanSubForm");
		}

		if (!this.spanField.subFormSpanTypeState) {
			throw new Error("SubForm instance's schema is type SPAN but is missing the SubFormSpanTypeState");
		}

		this.subFormSpanTypeState = this.spanField.subFormSpanTypeState;
	}

	get spanVectorField() {
		return this.spanField.getField(this.subFormSpanTypeState.vectorFieldId);
	}

	get spanTypeField() {
		return this.spanField.getField<FormModelFieldSelectList>(this.subFormSpanTypeState.typeFieldId);
	}

	get spanTypeMapping() {
		return SpanTypeOptionSet.forForm(this.spanField.getForm()).linkValueMapping;
	}

	get spanMidSpanIkePhoto() {
		if (!this.subFormSpanTypeState.midSpanIkePhotoFieldId) {
			throw new Error('Span is missing configured Mid Span IKE Photo field');
		}
		return this.spanField.getField(this.subFormSpanTypeState.midSpanIkePhotoFieldId);
	}

	spanValue(instance: CollectionModelFieldSubFormInstance): ISpan {
		return new SpanSubFormAdaptor(instance);
	}

	get spanAttachmentHeightFields(): FormModelField<FormModelFieldState>[] {
		const allHeightFields = this.spanField.getAllNestedChildrenFieldsOfType(IkeFieldType.HEIGHT);

		// @TODO Once we have wire subforms we should be using that linked field rather than hard coding the fields ID here
		const filteredHeightFields = allHeightFields.filter((field) => field.id !== PoleFieldIds.SPAN.WIRE.MID_SPAN_HEIGHT);

		return filteredHeightFields;
	}
}
